<div class="container mt-5 container-walai">

  <!-- Premium Hero Section -->
  <div class="category-hero">
    <div class="row g-0">
      <div class="col-lg-4">
        <div class="hero-img-container">
          <img *ngIf="CATIMG != ''" class="hero-img" [src]="CATIMG" alt="{{CATNAMEENG}}"
            onError="this.src='assets/images/bookcover/noimage.jpg'">
        </div>
      </div>
      <div class="col-lg-8">
        <div class="hero-content">
          <h2 class="hero-title">{{CATNAMETHAI}}</h2>
          <span class="hero-subtitle">{{CATNAMEENG}}</span>
          <p class="hero-description mb-0">
            {{DESCRIPTION}}
          </p>
        </div>
      </div>
    </div>
  </div>


  <!-- Subcategory Grid -->
  <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
    <div class="col" *ngFor="let cat of subCategorys">
      <div class="subcategory-card h-100">

        <div class="d-flex flex-column h-100">
          <h5 class="sub-title">{{cat.CATEGRPNAMETHAI}}</h5>
          <h6 class="sub-subtitle">({{cat.CATEGRPNAMEENG}})</h6>

          <div class="sub-desc position-relative">
            <div [innerHTML]="cat.CATEGRPDESC" class="text-truncate-3"></div>

            <div *ngIf="cat.CATEGRPDESCFull" class="mt-1">
              <a href="javascript:void(0)" class="read-more-link" placement="top" ngbPopover="{{cat.CATEGRPDESCFull}}"
                popoverTitle="Full Description">
                {{'Read more' | translate}} <i class="bi bi-arrow-right-short"></i>
              </a>
            </div>
          </div>

          <div class="mt-auto pt-3">
            <button class="btn-browse-modern" (click)="getSubject(cat)">
              <i class="bi bi-collection"></i>
              Browse {{cat.COUNT}} Subjects
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>


<!-- Modern Modal -->
<div class="modal fade" id="subjectModal" tabindex="-1" aria-labelledby="subjectModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <div class="d-flex align-items-center gap-2">
          <i class="bi bi-grid-3x3-gap-fill text-theme fs-4"></i>

          <h5 class=" mb-0" id="subjectModalLabel">{{CATEGRPNAMETHAI}}</h5>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <div class="p-4 bg-light">
          <div class="row g-2">
            <div class="col-md-6" *ngFor="let subject of subjects">
              <ng-container *ngIf="locationID!=''; else NoLocation">
                <a target="_blank" href="results?Ntk=AUTHLINK|LOCATION&Ntt={{subject.AUTHID}}|{{locationID}}"
                  class="subject-item d-flex align-items-center p-3 rounded-4 bg-white shadow-sm h-100 text-decoration-none">
                  <div
                    class="icon-box rounded-circle bg-theme-soft me-3 d-flex align-items-center justify-content-center flex-shrink-0"
                    style="width: 36px; height: 36px;">
                    <i class="bi bi-hash text-theme fs-5"></i>
                  </div>
                  <span class="text-dark fw-medium">{{subject.AUTHHEADING}}</span>
                  <i class="bi bi-chevron-right ms-auto text-secondary opacity-25"></i>
                </a>
              </ng-container>

              <ng-template #NoLocation>
                <a target="_blank" href="results?Ntk=AUTHLINK&Ntt={{subject.AUTHID}}"
                  class="subject-item d-flex align-items-center p-3 rounded-4 bg-white shadow-sm h-100 text-decoration-none">
                  <div
                    class="icon-box rounded-circle bg-theme-soft me-3 d-flex align-items-center justify-content-center flex-shrink-0"
                    style="width: 36px; height: 36px;">
                    <i class="bi bi-hash text-theme fs-5"></i>
                  </div>
                  <span class="text-dark fw-medium">{{subject.AUTHHEADING}}</span>
                  <i class="bi bi-chevron-right ms-auto text-secondary opacity-25"></i>
                </a>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer bg-light">
        <button type="button" class="btn btn-secondary rounded-pill px-4" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>